/*
 * @Description  : 
 * @Autor        : tianzhen
 * @Date         : 2026-01-02 20:02:03 +0800
 * @LastEditors  : tianzhen
 * @LastEditTime : 2026-01-21 19:56:35 +0800
 */
import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    children: [
      {
        path: 'user',
        name: 'user',
        component: () => import('../views/User.vue')
      },
      {
        path: 'job',
        name: 'job',
        component: () => import('../views/Job.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
